import React, {useEffect} from 'react';
import DashboardHero from '../../components/dashboard-hero/DashboardHero';
import Tracker from 'src/lib/analytics/tracker';
import {EventNames, EventProperty, ScreenNames} from 'src/lib/analytics/events';
import {FeatherIcon} from 'lucide-react';
import {FeatureFlags} from '../../contexts/FeatureFlags';
import DashboardNew from '../../components/dashboard-hero/DashboardNew';

export default function Dashboard() {
    useEffect(() => {
        Tracker.setCurrentScreenName(ScreenNames.HOME_SCREEN);
        Tracker.trackEvent(EventNames.SCREEN_VIEWS, {
            [EventProperty.ScreenName]: ScreenNames.HOME_SCREEN,
        });
    }, []);

    return (
        <section>
            <DashboardNew />
        </section>
    );
}
